import React, { ReactNode } from "react"
export function Button({ children, disabled, onClick, className, loading = false, type = 'button' }: { children: ReactNode, disabled?: boolean, className?: string, onClick?: () => void, loading?: boolean, type?: 'button' | 'submit' }): JSX.Element {
  return <button
    type={type}
    onClick={onClick}
    className={(className ?? '').concat(disabled ? " opacity-25" : "")}
    disabled={disabled || loading}
  >
    {children}
  </button>
}